export type CheckTypes =
  | 'reserving'
  | 'reserved'
  | 'unreserving'
  | 'confirmed'
  | 'unconfirming'
  | 'confirmed-to-be-canceled'
  | 'static';
export class Check {
  id: string;
  type: CheckTypes;
  value: any;
  collectIn?: number;
  as?: any;
  uid?: any;
  timestamp?: any;
  order?: number; //starting at 0
}
export type QuestionLevelAnswer = { [option_id: string]: Check };
export type SurveyLevelAnswer = { [question_id: string]: QuestionLevelAnswer };
export type ReplyItem = {
  id: string;
  uid?: string;
  as: string;
  forgeAlert?: boolean;
  displayName?: string;
  phoneNumber?: string;
  email?: string;
  timestamp?: number;
  snapshot: SurveyLevelAnswer;
};
